<template>
  <v-container>
    <template>
      <div class="text-center">
        <v-dialog
          v-model="dialog"
          width="609"
          @click:outside="closeModal"
          :retain-focus="false"
        >
          <v-card class="custom-card" rounded="0">
            <v-toolbar color="secondary" class="white--text">
              <v-toolbar-title class="font-weight-bold">
                Delete Equipment
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon class="white--text" @click="closeModal">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-form ref="addUser" lazy-validation autocomplete="off">
              <v-card-text class="black--text">
                <v-row>
                  <v-col cols="12">
                    <div>
                      Are you sure you want to delete this equipment?
                    </div>
                  </v-col>
                </v-row>
                <v-divider class="mt-5"></v-divider>
                <v-card-actions class="mt-5" style="padding-right: 0">
                  <v-spacer></v-spacer>
                  <v-btn
                    outlined
                    class="mr-2"
                    right
                    height="44"
                    depressed
                    color="primary"
                    @click="closeModal"
                  >
                    No
                  </v-btn>
                  <v-btn right height="44" width="100" color="primary" @click="deleteEquipment">
                    Yes
                  </v-btn>
                </v-card-actions>
              </v-card-text>
            </v-form>
          </v-card>
        </v-dialog>
      </div>
    </template>
  </v-container>
</template>
<script>
import loadingMixin from "@/mixins/LoadingMixin"
import gql from 'graphql-tag'
export default {
  data() {
    return {};
  },
  mixins: [loadingMixin],
  computed: {
    dialog() {
      return this.dialogI;
    },
  },
  props: {
    dialogI: {
      type: Boolean,
      required: true,
    },
    equipmentId: {
      type: Number,
      required: true
    }
  },
  methods: {
    closeModal() {
      this.$emit("closeDeleteDialog");
    },
    deleteEquipment () {
      this.startLoading()
      this.$apollo.mutate({
        // Query
        mutation: gql`mutation ($id: Int!){
          removeEquipment(id: $id) {
            success,
            message
          }
        }`,
        // Parameters
        variables: {
          id: Number(this.equipmentId),
        },
      }).then(async res => {
        // console.log(res)
        if (res.data.removeEquipment && res.data.removeEquipment.success) {
          this.stopLoading()
          this.closeModal()
          this.$emit('deleteEquipmentSuccess')
        }
      }).catch(async error => {
        console.log(error)
        this.stopLoading()
      })
    }
  },
};
</script>

<style></style>
